import { render } from "./callToAction.vue?vue&type=template&id=75925b5c&scoped=true"
import script from "./callToAction.vue?vue&type=script&lang=js"
export * from "./callToAction.vue?vue&type=script&lang=js"

import "./callToAction.vue?vue&type=style&index=0&id=75925b5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75925b5c"]])

export default __exports__